import { useState } from "react"
import { Badge, Col, Row } from "react-bootstrap";
import { HiMiniXMark } from "react-icons/hi2";
import { MdCloudDownload } from "react-icons/md";
import { SlMagnifier } from "react-icons/sl";

const InvoiceListItem = ({ type, invoice, pdfReader }) => {

    const [toggleDetails, setToggleDetails] = useState(false);
    const [isHover, setIsHover] = useState(false);


    const convertBase64ToBlock = (base64String) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        return URL.createObjectURL(blob);
    }


    const downloadPdf = (e, file_name, file) => {
        e.preventDefault();
        var linkSource = `data:application/pdf;base64,${file}`;

        const downloadLink = document.createElement('a');
        downloadLink.href = convertBase64ToBlock(file);
        downloadLink.download = file_name;
        downloadLink.click();
    }

    const viewPdf = (e, file) => {
        e.preventDefault();
        return pdfReader(file);
    }
    // style={isHover && {background: "#e3e3e3"}}
    return (
        <li key={`li-${type}-${invoice.id}`}>
            {type === "abrechnung" &&
                <>
                    <Row 
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                        onClick={() => setToggleDetails(!toggleDetails)}
                    >
                        <Col xs="7">
                            <b style={isHover? {borderBottom: "2px solid #0d6efd"}: null}>Abrechnung</b> &nbsp;
                            <small className="text-muted">
                                {new Date(invoice.x_eingangsdatum).toLocaleDateString('DE-de')}
                            </small>
                        </Col>
                        <Col xs={toggleDetails? "4":"5"} className="text-end">
                            {invoice.x_file_mahnung_name !== "False" && <Badge pill style={{ marginRight: 5 }} bg="violet">Mahnung</Badge>}
                            {invoice.x_file_stornorechnung_name !== "False" && <Badge pill bg="danger">Storno</Badge>}
                        </Col>
                        {toggleDetails &&
                            <Col xs="1">
                                <HiMiniXMark />
                            </Col>
                        }
                    </Row>
                    {toggleDetails &&
                        <div style={{ borderLeft: "2px solid #0d6efd", marginLeft: 3, paddingLeft: 10 }}>
                            <Row className="mt-2">
                                <Col xs="12">
                                    <small>
                                        <span className="text-muted">Abrechnungszeitraum:</span>  &nbsp;
                                        {new Date(invoice.x_abrechnungszeitraum_von).toLocaleDateString('DE-de')} - &nbsp;
                                        {new Date(invoice.x_abrechnungszeitraum_bis).toLocaleDateString('DE-de')}
                                    </small>
                                </Col>
                            </Row>
                            {invoice.x_file_abrechnung_name !== "False" &&
                                <Row className="mt-2">
                                    <Col xs="6">
                                        <a href="/download/abrechnung/"
                                            onClick={e => downloadPdf(e, invoice.x_file_abrechnung_name, invoice.x_file_abrechnung)}
                                            className="link-energo text-primary"
                                        >
                                            <MdCloudDownload /> Download
                                        </a>
                                    </Col>
                                    <Col xs="6" className="text-center">
                                        <a href="/ansehen/abrechnung"
                                            onClick={e => viewPdf(e, invoice.x_file_abrechnung)}
                                            className="link-energo text-primary"
                                        >
                                            <SlMagnifier /> Ansehen
                                        </a>
                                    </Col>
                                </Row>
                            }
                            {invoice.x_file_abrechnung2_name !== "False" &&
                                <Row className="mt-2">
                                    <Col xs="6">
                                        <a href="/download/abrechnung2/"
                                            onClick={e => downloadPdf(e, invoice.x_file_abrechnung2_name, invoice.x_file_abrechnung2)}
                                            className="link-energo text-primary"
                                        >
                                            <MdCloudDownload /> Abrechnung 2
                                        </a>
                                    </Col>
                                    <Col xs="6" className="text-center">
                                        <a
                                            href="/ansehen/abrechnung"
                                            onClick={e => viewPdf(e, invoice.x_file_abrechnung2)}
                                            className="link-energo text-primary"
                                        >
                                            <SlMagnifier /> Ansehen
                                        </a>
                                    </Col>
                                </Row>
                            }
                            {invoice.x_file_mahnung_name !== "False" &&
                                <Row className="mt-2">
                                    <Col xs="6">
                                        <a
                                            href="/download/mahnung/"
                                            onClick={e => downloadPdf(e, invoice.x_file_mahnung_name, invoice.x_file_mahnung)}
                                            className="link-energo text-violet"
                                        >
                                            <MdCloudDownload /> Mahnung
                                        </a>
                                    </Col>
                                    <Col xs="6" className="text-center">
                                        <a
                                            href="/ansehen/abrechnung"
                                            onClick={e => viewPdf(e, invoice.x_file_mahnung)}
                                            className="link-energo text-violet"
                                        >
                                            <SlMagnifier /> Ansehen
                                        </a>
                                    </Col>
                                </Row>
                            }
                            {invoice.x_file_stornorechnung_name !== "False" &&
                                <Row className="mt-2">
                                    <Col xs="6">
                                        <a
                                            href="/download/storno/"
                                            onClick={e => downloadPdf(e, invoice.x_file_stornorechnung_name, invoice.x_file_stornorechnung)}
                                            className="link-energo text-danger"
                                        >
                                            <MdCloudDownload /> Stornorechnung
                                        </a>
                                    </Col>
                                    <Col xs="6" className="text-center">
                                        <a
                                            href="/ansehen/abrechnung"
                                            onClick={e => viewPdf(e, invoice.x_file_stornorechnung)}
                                            className="link-energo text-danger"
                                        >
                                            <SlMagnifier /> Ansehen
                                        </a>
                                    </Col>
                                </Row>
                            }
                        </div>
                    }
                </>
            }
            {type === "poolrechnung" &&
                <>
                    <Row 
                        onClick={() => setToggleDetails(!toggleDetails)}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                    >
                        <Col xs={toggleDetails? "11" : "12"}>
                            <b style={isHover? {borderBottom: "2px solid #a2c13f"}:null}>{invoice.x_rechnungsart}</b> &nbsp;
                            <small className="text-muted">
                                {new Date(invoice.x_rechnungsdatum).toLocaleDateString('DE-de')}
                            </small>
                        </Col>
                        {toggleDetails &&
                            <Col xs="1">
                                <HiMiniXMark />
                            </Col>
                        }
                    </Row>
                    {toggleDetails &&
                        <div style={{ borderLeft: "2px solid #a2c13f", marginLeft: 3, paddingLeft: 10 }}>
                            <Row className="mt-2">
                                <Col xs="12">
                                    <small>
                                        <span className="text-muted">Rechnungsdatum:</span>  &nbsp;
                                        {new Date(invoice.x_rechnungsdatum).toLocaleDateString('DE-de')}
                                    </small>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col xs="6">
                                    <a href="/download/abrechnung/"
                                        onClick={e => downloadPdf(e, invoice.x_file_poolrechnung_name, invoice.x_file_poolrechnung)}
                                        className="link-energo"
                                    >
                                        <MdCloudDownload /> Download
                                    </a>
                                </Col>
                                <Col xs="6" className="text-center">
                                    <a href="/ansehen/abrechnung"
                                        onClick={e => viewPdf(e, invoice.x_file_poolrechnung)}
                                        className="link-energo"
                                    >
                                        <SlMagnifier /> Ansehen
                                    </a>
                                </Col>
                            </Row>
                        </div>
                    }
                </>
            }
            {type === "vorschreibung" &&
                <>
                    <Row 
                        onClick={() => setToggleDetails(!toggleDetails)}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                    >
                        <Col xs="7">
                            <b style={isHover? {borderBottom: "2px solid #ffc107"}:null}>Vorschreibung</b> &nbsp;
                            <small className="text-muted">
                                {new Date(invoice.create_date).toLocaleDateString('DE-de')}
                            </small>
                        </Col>
                        <Col xs={toggleDetails ? "4": "5"} className="text-end">
                            {invoice.x_file_mahnung_name !== "False" && <Badge pill style={{ marginRight: 5 }} bg="violet">Mahnung</Badge>}
                        </Col>
                        {toggleDetails &&
                            <Col xs="1">
                                <HiMiniXMark />
                            </Col>
                        }
                    </Row>
                    {toggleDetails &&
                        <div style={{ borderLeft: "2px solid #ffc107", marginLeft: 3, paddingLeft: 10 }}>
                            <Row className="mt-2">
                                <Col xs="12">
                                    <small>
                                        <span className="text-muted">Rechnungsdatum:</span>  &nbsp;
                                        {new Date(invoice.create_date).toLocaleDateString('DE-de')}
                                    </small>
                                </Col>
                            </Row>
                            {invoice.x_file_vorschreibung_name !== "False" &&
                                <Row className="mt-2">
                                    <Col xs="6">
                                        <a href="/download/abrechnung/"
                                            onClick={e => downloadPdf(e, invoice.x_file_vorschreibung_name, invoice.x_file_vorschreibung)}
                                            className="link-energo text-warning"
                                        >
                                            <MdCloudDownload /> Download
                                        </a>
                                    </Col>
                                    <Col xs="6" className="text-center">
                                        <a href="/ansehen/abrechnung"
                                            onClick={e => viewPdf(e, invoice.x_file_vorschreibung)}
                                            className="link-energo text-warning"
                                        >
                                            <SlMagnifier /> Ansehen
                                        </a>
                                    </Col>
                                </Row>
                            }
                            {invoice.x_file_mahnung_name !== "False" &&
                                <Row className="mt-2">
                                    <Col xs="6">
                                        <a href="/download/abrechnung/"
                                            onClick={e => downloadPdf(e, invoice.x_file_poolrechnung_name, invoice.x_file_poolrechnung)}
                                            className="link-energo text-violet"
                                        >
                                            <MdCloudDownload /> Mahnung
                                        </a>
                                    </Col>
                                    <Col xs="6" className="text-center">
                                        <a href="/ansehen/abrechnung"
                                            onClick={e => viewPdf(e, invoice.x_file_poolrechnung)}
                                            className="link-energo text-violet"
                                        >
                                            <SlMagnifier /> Ansehen
                                        </a>
                                    </Col>
                                </Row>
                            }
                        </div>
                    }
                </>
            }
        </li>
    )
}
export default InvoiceListItem;